var map = {
	"./add_col_after.svg": "7l5u",
	"./add_col_before.svg": "Pf0R",
	"./add_row_after.svg": "uGRj",
	"./add_row_before.svg": "nLRf",
	"./bold.svg": "wbGs",
	"./checklist.svg": "N++K",
	"./code.svg": "bVBT",
	"./combine_cells.svg": "gUaP",
	"./delete_col.svg": "7CNn",
	"./delete_row.svg": "03tD",
	"./delete_table.svg": "l0Bx",
	"./facebook.svg": "J/ZG",
	"./github.svg": "I9O5",
	"./google.svg": "2kAn",
	"./hr.svg": "c45S",
	"./image.svg": "fKcu",
	"./italic.svg": "pcpc",
	"./link.svg": "7jgS",
	"./mention.svg": "rXnS",
	"./ol.svg": "QL5x",
	"./paragraph.svg": "VU+n",
	"./quote.svg": "kApH",
	"./redo.svg": "GPHZ",
	"./remove.svg": "cmo1",
	"./strike.svg": "WZUL",
	"./table.svg": "/L3u",
	"./ul.svg": "kelG",
	"./underline.svg": "cC+X",
	"./undo.svg": "f6uR"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Fpfn";